import { useQuery } from "@tanstack/react-query";
import { api, type MeResponse } from "./api";

/** Is this feature available to the current user? (The owner always has everything; the server enforces it too.) */
export function useFeature(key: string): boolean {
  const me = useQuery({
    queryKey: ["me"],
    queryFn: () => api<MeResponse>("/auth/me"),
    staleTime: 60_000,
  });
  if (me.data?.user?.role === "owner") return true;
  return me.data?.features?.[key] !== false;
}

/** Same as useFeature but for several keys in one call (usable inside loops/filters). */
export function useFeatureCheck(): (key: string) => boolean {
  const me = useQuery({
    queryKey: ["me"],
    queryFn: () => api<MeResponse>("/auth/me"),
    staleTime: 60_000,
  });
  const owner = me.data?.user?.role === "owner";
  return (key) => owner || me.data?.features?.[key] !== false;
}
